module.exports = __webpack_public_path__ + "img/win-icon3.b4bb638.png";